import TopHeaderAlt from "../../components/topHeaderAlt/TopHeaderAlt";
import { BaseButton } from "../../components/base";
import { useNavigate } from "react-router-dom";
import URIs from "../../utils/uri";
import { useTheme, Typography } from "@mui/material";
import useAuth from "../../hooks/useAuth";
import BuyPureGold from "../../components/order/BuyPureGold";
import BuyProduct from "../../components/order/BuyProduct";
import SellPureGold from "../../components/order/SellPureGold";
import SellProduct from "../../components/order/SellProduct";
import MenuDetails from "../../components/menuDetails/MenuDetails";
import ProfileOverview from "../../components/menuDetails/ProfileOverview";
import LogoutButton from "../../components/menuDetails/LogoutButton";
import { useLocation } from "react-router-dom";

const Order = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const {auth} = useAuth();
    const location = useLocation();
    const orderState = location.state
    
    return (
        <div>
            <TopHeaderAlt>
                <Typography
                    variant="caption"
                    color='textDefault'
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        justifyItems:"center",
                        width: "80%",
                    }}
                >
                    {orderState.orderType === 'buy' ? "خرید " : "فروش "}
                    {
                        orderState.productName
                    }
                </Typography>
            </TopHeaderAlt>
            {orderState.orderType === 'buy'
            ? 
                <>
                    {orderState.productType === 0
                    ?
                        <BuyPureGold
                            productId = {orderState.productId}
                        />
                    :
                        <BuyProduct
                            productId = {orderState.productId}
                        />
                    }
                </> 
            :
                <>
                    {orderState.productType === 0
                    ?
                        <SellPureGold
                            productId = {orderState.productId}
                        />
                    :
                        <SellProduct
                            productId = {orderState.productId}
                        />
                    }
                </> 
            }
        </div>
    )
}
export default Order;